module.exports = __webpack_public_path__ + "img/numpy.fb8cd346.svg";